<template lang="pug">
  Auth(@loggedIn="onLoggedIn" @loginFailed="onFailedAuthentication")
    Header(:content="headerContent")
    ModalPage(
      v-if="uid"
      @closeModalPage="closeModalPage"
      modalPageContentId="report_detail"
      :modalHeaderContent="modalHeaderContent"
      :showModal="showModalPage")
    div.wrap-trainer-report-list.f.fh
      ModuleTrainerReportList(v-if="trainer" :trainer="trainer")
</template>

<style lang="scss" scoped>
.wrap-trainer-report-list {
  width: 100%;
  min-height: 100vh;
}
</style>

<script>
import db from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import Auth from '@/components/auth'
import Header from '@/components/shared/Header.vue'
import ModalPage from '@/components/shared/ModalPage.vue'
import ModuleTrainerReportList from '@/components/module/ModuleTrainerReportList'
import { database } from '@shared/database'

export default {
  components: {
    Auth,
    Header,
    ModalPage,
    ModuleTrainerReportList
  },
  data () {
    return {
      trainer: null,
      headerContent: {
        label: 'レポート一覧',
        leftAction: {
          icon: 'playlist_add_check',
          color: '#fff',
          method: this.onHeaderLeft
        },
        rightAction: {
          icon: 'home',
          color: '#fff',
          method: this.onHeaderRight
        }
      },
      modalHeaderContent: {
        label: '',
        leftAction: {
          icon: 'navigate_before',
          color: '#fff',
          method: this.onModalHeaderLeft
        }
      },
      showModalPage: false
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  watch: {
    '$route': function (to, from) {
      if (to.path !== from.path) {
        if (this.$route.params.lectureIndex) {
          this.showModalPage = true
          // this.modalHeaderContent.label = this.course.lectures[this.$route.params.lectureIndex].title
        } else {
          this.showModalPage = false
        }
      }
    }
  },
  async created () {
    if (this.$route.params.lectureIndex) {
      this.showModalPage = true
      // this.modalHeaderContent.label = this.course.lectures[this.$route.params.lectureIndex].title
    } else {
      this.showModalPage = false
    }
    // this.trainer = await db.collection('TRAINERS')
    //   .where("authedUid", "==", this.uid)
    //   .get()
    //   .then(q => { 
    //     return q.docs[0].data()
    //   })
  },
  methods: {
    onFailedAuthentication () {
      this.$router.push('/sign-in')
    },
    async onLoggedIn () {
      // this.trainer = await db.collection('TRAINERS')
      //   .where('authedUid', '==', this.uid)
      //   .get()
      //   .then(q => { 
      //     var trainer = q.docs[0].data()
      //     trainer.trainerId = q.docs[0].id
      //     return trainer
      //   })
      this.trainer = await database.getTrainerByUid(this.uid)
    },
    onHeaderLeft () {
      this.$router.push(`/trainer/report_list`)
    },
    onHeaderRight () {
      this.$router.push(`/trainer/home`)
    },
    closeModalPage () {
      this.showModalPage = false
    },
    onModalHeaderLeft () {
      this.$router.push('/trainer/report_list')
    }
  }
}
</script>
